<template>
  <div
    ref="orderListContainer"
    class="order-contain"
  >
    <div class="top-header">
      <div class="top__bg">
        <picture>
          <source
            srcset="https://m.hellobike.com/53bc859edb.png 2x, https://m.hellobike.com/fc24f6af6f.png 3x"
            type="image/webp"
          >
          <img
            class="top__bg-layer"
            src="https://m.hellobike.com/fc24f6af6f.png"
            srcset="https://m.hellobike.com/53bc859edb.png 2x, https://m.hellobike.com/fc24f6af6f.png 3x"
            width="375"
            height="450"
          >
        </picture>
      </div>
      <div class="top__safe-area" />
      <div class="top-title">
        <img
          v-if="isHelloFamilyApp"
          src="https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/a1b25d20-c418-4ce0-9d0a-1c141af18707.svg"
          width="24"
          height="24"
          @click="goBack"
        >
        <div>
          购买记录
        </div>
      </div>
    </div>
    <div class="top-content">
      <div class="panel">
        <van-tabs
          v-model="active"
          @click="onTabClick"
        >
          <van-tab
            title="生效中"
          />
          <van-tab
            title="全部"
          />
        </van-tabs>
        <div
          v-if="active === 0"
          key="1"
        >
          <OrderList
            ref="effectiveList"
            :show-all="false"
          />
        </div>
        <!-- 赋予key值，可以保证相同组件DOM重新渲染 -->
        <div
          v-if="active === 1"
          key="2"
        >
          <OrderList
            ref="allList"
            :show-all="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  nextTick,
  onMounted,
  inject,
} from 'vue';
import { Native } from '@hb/mbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { isHelloFamilyApp } from '~mall/common/env/env';
// 保持滚动条位置的方法
import { useKeepScroll } from '~mall/common/utils/useKeepScroll';
import OrderList from './components/OrderList.vue';
// import HeaderNew from '@/common/components/Header.vue';
import { useSessionStorageRef } from './useSessionStorageRef';

export default {
  name: 'MallOrder',
  components: {
    // HeaderNew,
    OrderList,
  },
  setup() {
    const active = useSessionStorageRef(0, 'orderListActive');
    const { el: orderListContainer } = useKeepScroll();
    const styleVersion = inject('styleVersion');

    onMounted(() => {
      if (isHelloFamilyApp) {
        Native.callNative({
          classMap: 'NavBar',
          method: 'setStatusBar',
          params: { isShowStatusBar: true },
        });
        Native.callNative({
          classMap: 'NavBar',
          method: 'setStatusBarColor',
          params: { isShowStatusBar: true, isDarkFont: true, colorCode: '#ffd2dc' },
        });
      }
      // 生效中全部 曝光埋点
      UBT.moduleExpose({
        pageId: 'platform_couponMall_orderList',
        categoryId: 'platform',
        moduleId: 'platform_inEffectTab',
        contentId: 'platform_inEffectTab',
        exposureTimes: 1,
        businessInfo: {
          experimentalGroup: styleVersion,
        },
      });
      UBT.moduleExpose({
        pageId: 'platform_couponMall_orderList',
        categoryId: 'platform',
        moduleId: 'platform_allOrder',
        contentId: 'platform_allOrder',
        exposureTimes: 1,
        businessInfo: {
          experimentalGroup: styleVersion,
        },
      });
    });

    const goBack = () => {
      try {
        Native.goBack();
      } catch (error) {
        window.history.go(-1);
      }
    };

    const onTabClick = (name) => {
      if (name === 0) {
        UBT.clickButton({
          pageId: 'platform_couponMall_orderList',
          buttonName: 'platform_inEffectTab',
          categoryId: 'platform',
          businessInfo: {
            experimentalGroup: styleVersion,
          },
        });
      } else if (name === 1) {
        UBT.clickButton({
          pageId: 'platform_couponMall_orderList',
          buttonName: 'platform_allOrder',
          categoryId: 'platform',
          businessInfo: {
            experimentalGroup: styleVersion,
          },
        });
      }
      nextTick(() => {
        orderListContainer.value?.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    };

    return {
      active,
      onTabClick,
      orderListContainer,
      isHelloFamilyApp,
      goBack,
    };
  },
};
</script>

<style lang="less" scoped>
  .order-contain {
    overflow: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100vh;
  }

  .top-header {
    flex-shrink: 0;

    .top__bg {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      z-index: 0;
      height: 100vh;
      background: linear-gradient(180deg, #ffc8d5 0%, #ffe6eb 63.98%, #fffafb 100%);

      &-layer {
        display: block;
        width: 100%;
      }
    }

    .top__safe-area {
      display: block;
      height: constant(safe-area-inset-top);
      height: env(safe-area-inset-top);
    }

    .top-title {
      position: relative;
      display: flex;
      padding-top: 13px;
      justify-content: center;
      height: 36px;
      box-sizing: border-box;
      /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      color: #242729;

      img {
        position: absolute;
        left: 12px;
      }
    }
  }

  .top-content {
    position: relative;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .panel {
      flex-grow: 1;
      border-radius: 0.16rem 0.16rem 0 0;
      margin-top: 0.12rem;
      background: #f0f3f5;
    }
  }

  /deep/ .van-tabs__nav {
    box-sizing: border-box;
    padding: 0;
    background: transparent;
  }

  .van-tab {
    position: relative;
  }

  /deep/ .van-tabs__line {
    position: absolute;
    bottom: 6px;
    width: 16px !important;
    height: 3px;
    background-color: #ff5950;
  }
</style>
